import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export default function DSelectLoadingIndicator({ innerProps, }) {
    return (_jsx("div", Object.assign({ className: classNames({
            'd-select__indicator': true,
            'd-select__loading-indicator': true,
        }) }, innerProps, { children: _jsx("span", { className: "spinner-border spinner-border-sm", role: "status", "aria-hidden": "true", children: _jsx("span", { className: "visually-hidden", children: "Loading..." }) }) })));
}
//# sourceMappingURL=DSelectLoadingIndicator.js.map